import { classNames } from "primereact/utils";

import { Illustration } from "../../illustration";
import { useEmptyStateContext } from "../empty-state.context";
import type { EmptyStateIllustrationProps } from "../types-empty-state";

/** Ilustração do DS (decorativa: o título já diz o que aconteceu). */
export function EmptyStateIllustration({
  name,
  className,
  testId,
  ...rest
}: EmptyStateIllustrationProps) {
  const { illustrationSize, partTestId, classNames: parts } = useEmptyStateContext();

  return (
    <Illustration
      size={illustrationSize}
      className={classNames(parts.illustration, className)}
      testId={testId ?? partTestId("illustration") ?? `empty-state-${name}`}
      name={name}
      {...rest}
    />
  );
}
EmptyStateIllustration.displayName = "EmptyState.Illustration";
